import React from 'react'

import { HashRouter as Router, Routes, Route } from 'react-router-dom'

import routes, { RoutesNames } from './routes'

const AppRoutes = () => (
  <Router basename={RoutesNames.ROOT}>
    <Routes>
      {routes.map((route) => (
        <Route {...route} key={route.path} />
      ))}
    </Routes>
  </Router>
)

export default AppRoutes
